import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { handleAddModifyOperation } from '../../../../Api/ApiMethods';
import PropTypes from 'prop-types';

const ExpertWitnessDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedExpertWitness, refreshData }) => {
    const initialExpertWitnessData = {
        id: '',
        fullName: '',
    };

    const [expertWitnessData, setExpertWitnessData] = useState(initialExpertWitnessData);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isOpen) {
            if (mode === 'modify' && selectedExpertWitness) {
                setExpertWitnessData({ ...initialExpertWitnessData, ...selectedExpertWitness });
            } else {
                resetForm();
            }
            setErrors({});
        }
    }, [mode, selectedExpertWitness, isOpen]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let processedValue = value;

        if (name === 'fullName' && typeof processedValue === 'string') {
            processedValue = processedValue.replace(/\b\w/g, char => char.toLocaleUpperCase('tr-TR'))
                .replace(/\s+/g, ' '); // Sadece çoklu boşlukları tek boşluğa çevir, trim yapma
        }

        setExpertWitnessData(prevData => ({ ...prevData, [name]: processedValue }));

        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
        }
    };

    const validateForm = () => {
        const validationErrors = {};

        if (!expertWitnessData.fullName?.trim()) {
            validationErrors.fullName = 'Ad Soyad zorunludur.';
        } else if (expertWitnessData.fullName.trim().length < 2) {
            validationErrors.fullName = 'Ad Soyad en az 2 karakter olmalıdır.';
        } else if (expertWitnessData.fullName.trim().split(' ').filter(word => word.length > 0).length < 2) {
            validationErrors.fullName = 'En az iki kelime girmelisiniz.';
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const resetForm = () => {
        setExpertWitnessData(initialExpertWitnessData);
        setErrors({});
    };

    const handleCancel = () => {
        resetForm();
        toggle();
    };

    const handleOperation = async () => {
        if (!validateForm()) {
            toast.error('Lütfen formdaki hataları düzeltin.');
            const firstErrorKey = Object.keys(errors).find(key => errors[key]);
            if (firstErrorKey) document.getElementById(firstErrorKey)?.focus();
            return;
        }

        const payload = {
            fullName: expertWitnessData.fullName.trim().toLocaleUpperCase('tr-TR'),
            ...(mode === 'modify' && selectedExpertWitness?.id && { id: selectedExpertWitness.id })
        };

        console.log("Sending Payload:", payload);

        try {
            await handleAddModifyOperation({
                apiEndpoint,
                selectedItem: mode === 'modify' ? { id: selectedExpertWitness?.id } : null,
                mode,
                data: payload,
                refreshDataCallback: refreshData,
                componentName: 'Bilirkişi',
            });
            toggle();
        } catch (error) {
            console.error("Bilirkişi operasyonu başarısız:", error);
        }
    };

    const getModalTitle = () => {
        return mode === 'add' ? 'Bilirkişi Ekle' : 'Bilirkişi Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} backdrop="static">
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="fullName">Ad Soyad <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="fullName"
                            name="fullName"
                            value={expertWitnessData.fullName || ''}
                            onChange={handleInputChange}
                            placeholder="Bilirkişi Ad Soyad"
                            invalid={!!errors.fullName}
                        />
                        <FormFeedback>{errors.fullName}</FormFeedback>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleOperation}>
                    {getButtonLabel()}
                </Button>
                <Button color="secondary" onClick={handleCancel} className="ms-2">
                    İptal
                </Button>
            </ModalFooter>
        </Modal>
    );
};

ExpertWitnessDataModal.propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['add', 'modify']).isRequired,
    selectedExpertWitness: PropTypes.object,
    refreshData: PropTypes.func.isRequired,
};

export default ExpertWitnessDataModal;
